<div class="appointment" [class.finished]="finished" (click)="openOptions($event)">
  <div class="appointment-wrapper">
    <div class="appointment-line"></div>
    <div class="appointment-content">
      <div class="appointment-name">{{appointment.subject}}</div>
      <div class="appointment-time">{{appointment.startDateMoment.format("DD.MM.YYYY")}} {{appointment.startDateMoment.format("HH:mm")}} - {{appointment.endDateMoment.format("HH:mm")}} Uhr</div>
      <div class="appointment-time">{{appointment.location}}</div>
      <div class="appointment-users">
        @for (employee of appointment.attendees; track employee) {
          <div class="user-circle" [hoverTitle]="{text: employee?.email, position: 'top'}">
            @if(employee?.email){
              {{employee.email[0].toUpperCase()}}
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>